<script setup lang="ts">
import LeButton from "@dsk/components/Button/LeButton.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

import LeErrorResult from "./LeErrorResults.vue";

const { t } = useI18n();
const router = useRouter();

const subscriptionHref = computed<string>(() => router.resolve({ name: "subscription" }).href);

const trackSubscriptionCta = () => {
  MatomoHelper.sendEvent(
    MatomoEventCategory.SubscriptionPage,
    MatomoEventAction.ClickCallToAction,
    "Free searches used"
  );
};
</script>

<template>
  <LeErrorResult>
    <template #header>
      {{ t("le-error-results.free-searches-used.headline") }}
    </template>
    <template #paragraph1>
      {{ t("le-error-results.free-searches-used.paragraph1") }}
    </template>
    <template #paragraph2>
      {{ t("le-error-results.free-searches-used.paragraph2") }}
    </template>
    <template #button>
      <LeButton tag="a" :href="subscriptionHref" variant="outline" @click="trackSubscriptionCta()">{{
        t("le-error-results.free-searches-used.button")
      }}</LeButton>
    </template>
  </LeErrorResult>
</template>
